export default {
  create: 'إنشاء',
}
